import React, { useContext, useState, useEffect, createContext, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { authentication, db } from './index';
import { collection, query, where, getDocs } from 'firebase/firestore/lite';
import { getRecentSearchTerms } from './localStorageHandler';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const sortByCreateDate = (a, b) => {
        if (a.created > b.created)
            return 1;
        else
            if (b.created > a.created)
                return -1;
        return 0;
    }

    const fetchRecipes = useCallback(async (email) => {
        const recipesRef = collection(db, "recipes");
        const q = query(recipesRef, where("owner", "==", email));
        try {
            const querySnapshot = await getDocs(q);
            const recipesFromFirestore = querySnapshot.docs.map((doc) => doc.data()).sort(sortByCreateDate);
            dispatch({ type: 'SET_RECIPES', recipes: recipesFromFirestore });
            const searchTerms = getRecentSearchTerms();
            dispatch({ type: 'SET_SEARCH_TERMS', searchTerms: searchTerms });
        }
        catch (error) {
            console.log(error.message);
        }
    }, [dispatch]);

    useEffect(() => {
        authentication.onAuthStateChanged((user) => {
            if (user)
                fetchRecipes(user.email);
            setUser(user);
            setLoading(false);
            if (user && location.pathname === '/')
                navigate('dashboard', { replace: true });
        });
    }, [user, navigate, location, dispatch, fetchRecipes]);

    const value = { user };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
}